export const iconFontAwesomeConstructionMound = (
	<i className="fa-solid fa-mound"></i>
);
